import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { fetchCreateMeta } from 'services/vendorOnboarding/api';
import VendorOnboardingLayout from './VendorOnboardingLayout';
import VendorOnboardingForm from './VendorOnboardingForm';

const VendorOnboardingCreate = () => {
  const { firmName, name, email, tokenUserId } = useParams();
  const history = useHistory();
  const [meta, setMeta] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setIsLoading(true);
      const res = await fetchCreateMeta(firmName, name, email, tokenUserId);
      if (cancelled) return;
      setIsLoading(false);
      if (!res.success) {
        toast.error(res.message || 'Unable to load form');
        return;
      }
      if (res.data?.already_submitted) {
        history.replace('/vendor-onboarding/submitted');
        return;
      }
      setMeta(res.data);
    })();
    return () => {
      cancelled = true;
    };
  }, [firmName, name, email, tokenUserId, history]);

  return (
    <VendorOnboardingLayout title="Vendor Onboarding Form" isLoading={isLoading}>
      {!isLoading && meta && (
        <VendorOnboardingForm mode="create" meta={meta} />
      )}
    </VendorOnboardingLayout>
  );
};

export default VendorOnboardingCreate;
